import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setCookie } from "../../../utils";
import { getProfile } from "../../../services/profile";

const ProviderToken = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchUser = async () => {
      const token = searchParams.get("token");
      const skyToken = searchParams.get("skypoint-token");

      if (!token || !skyToken) {
        navigate("/login");
        return;
      }

      setCookie(token, "token");
      setCookie(skyToken, "skypoint_token");
      localStorage.setItem("isProviderView", true);

      await getProfile(true, token);

      navigate("/home");
    };

    fetchUser();
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        padding: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src="/assets/images/logo2.png"
        alt="logo"
        style={{ width: "20%", objectFit: "contain" }}
      />
    </div>
  );
};

export default ProviderToken;
